import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPuzzleAndPuzzleType } from "Store/features/puzzleSlice";
import { makeDeletePuzzleRequest } from "API/Puzzles";
import { DateTime } from "luxon";

import GameType from "./GameType";

import { useNavigate } from "react-router-dom";

import { makeGetProfileRequest } from "API/Profile";
import { setProfile } from "Store/features/clientProfileSlice";

import { REQUESTS } from "Util/constants";

import "./PuzzleTable.css";

const PuzzleTable = (props) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { dashboadPuzzles } = props;
  const authToken = useSelector((state) => state.authSlice.authToken);
  const deletePuzzleRequestStatus = useSelector(
    (state) => state.stateSlice.requests[REQUESTS.DELETE_PUZZLE]
  );

  const getProfile = useCallback(async () => {
    const profile = await makeGetProfileRequest(dispatch, authToken);
    console.log('profile', profile)
    dispatch(setProfile(profile));
  }, [authToken, dispatch, setProfile]);
  useEffect(() => {
    console.log()
    if (deletePuzzleRequestStatus === "success") {
      getProfile();
    }
  }, [deletePuzzleRequestStatus]);

  const loadEditorPuzzle = useCallback(
    (puzzleId, puzzle, puzzleType) => {
      dispatch(setPuzzleAndPuzzleType({ puzzleId, puzzle, puzzleType, edit: true }));
    },
    [setPuzzleAndPuzzleType]
  );

  const deletePuzzle = useCallback(
    async (puzzleId) => {
      await makeDeletePuzzleRequest(dispatch, authToken, { puzzleId });
    },
    [authToken]
  );

  return (
    <div className="puzzle-table-container">
      {dashboadPuzzles ? (
        <table>
          <thead>
            <tr>
              <th>Game Type</th>
              {/* {true ? <th>puzzle_id</th> : null} */}
              <th>Title</th>
              <th>Publicaton Date</th>
              <th>Last Edited Date</th>
              <th>Game Loads</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {dashboadPuzzles?.map((p) => (
              <tr>
                <td>
                  <GameType game={p.type} />
                </td>
                {/* {true ? <td name={p.title}>{p.id}</td> : null} */}
                <td>{p.title || '-'}</td>
                <td>
                  {DateTime.fromMillis(p.creationDate).toLocaleString(
                    DateTime.DATETIME_MED
                  )}
                </td>
                <td>
                  {DateTime.fromMillis(p.lastEditDate).toLocaleString(
                    DateTime.DATETIME_MED
                  )}
                </td>
                <td>{p.accessCount}</td>
                <td className="actions-cell">
                  <div className="actions-buttons-container">
                    <div
                      className="actions-cell-action-button"
                      onClick={() => loadEditorPuzzle(p.id, p.puzzle, p.type)}
                    >
                      Edit
                    </div>
                    <div
                      className="actions-cell-action-button"
                      onClick={() => navigate(`/play/puzzle/${p.id}`)}
                    >
                      Publish
                    </div>
                    <div
                      className="actions-cell-action-button"
                      onClick={() => deletePuzzle(p.id)}
                    >
                      Delete
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : null}
    </div>
  );
};

export default PuzzleTable;
